// Presenter Archetype — shared report model (screen result == PDF == text).
// Exact JS port of `backend/presenter_archetype/report_model.py`. Builds ONE
// plain object from (answers, language) consumed identically by the instant
// on-screen result, the `.txt` export (`textExport.js`) and used to confirm
// what the backend's PDF will contain before a user downloads it.

import content from "./content.json";
import { scorePresenterArchetype } from "./scoring";

export const resolveLanguage = (language) =>
  content.languages.includes(language) ? language : content.defaultLanguage;

// This question's 4 options in the brief's fixed A/B/C/D display order —
// NOT the JSON's own per-language key-insertion order.
export const orderedOptions = (questionIndex, language) => {
  const lang = resolveLanguage(language);
  const optionsById = content.content[lang].questions[questionIndex].options;
  return content.optionOrder[questionIndex].map((id) => ({ id, label: optionsById[id] }));
};

export const buildReportModel = (answers, language) => {
  const lang = resolveLanguage(language);
  const c = content.content[lang];
  const result = scorePresenterArchetype(answers);
  const { leaders, secondary, stretch, scores } = result;

  const profilesFor = (ids) =>
    content.archetypeOrder.filter((id) => ids.includes(id)).map((id) => ({ id, ...c.profiles[id] }));

  const leaderProfiles = profilesFor(leaders);
  const isBlend = leaders.length > 1;
  let blendText = null;
  if (leaders.length === 2) blendText = c.blends[leaders.join("+")];
  else if (leaders.length === 3) blendText = c.ui.broadBlend;

  return {
    language: lang,
    ui: c.ui,
    leaders,
    leaderProfiles,
    secondary,
    secondaryProfiles: profilesFor(secondary),
    stretch,
    stretchProfiles: profilesFor(stretch),
    scores,
    isBlend,
    blendText,
    archetypeOrder: content.archetypeOrder,
    // All 4 profiles, not just leader/secondary/stretch — the "answer
    // pattern" bars always name all 4 archetypes, even one that belongs
    // to none of those 3 categories (e.g. a 4/2/1/0 split).
    allProfilesById: Object.fromEntries(content.archetypeOrder.map((id) => [id, c.profiles[id]])),
    version: content.version,
    // New-in-this-brief direct-PDF label, distinct from `ui.download`
    // (which is the pre-existing reference app's text action-plan button).
    pdfButtonLabel: content.extensions.directPdf.labels[lang],
  };
};
